import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import {
	CLOSE_SWAP_MODAL,
	GET_SELECTED_SWAP,
	GET_SIZE,
	GET_SWAP_CLICKED_REPORT,
	GET_SWAP_OPEN,
	GET_SWAP_OPTIONS,
	SEND_REPORT,
	SET_SELECTED_SWAP,
	UPDATE_VISIBLE_INGREDIENTS,
} from '@/store/types';
import { ProductShoppingListItem } from '@/interfaces/ProductShoppingListItem';
import { CardSize } from '@/interfaces/Card';
import { VuexAction } from '@/@types/index.d';
import { IReport } from '@/interfaces/IReport';

@Component({
	name: 'Swap',
	components: {},
})
export default class Swap extends Vue {
	@Getter(GET_SWAP_OPEN) getSwapOpen!: boolean;

	@Getter(GET_SIZE) getSize!: CardSize;

	@Getter(GET_SELECTED_SWAP) getSelectedSwap!: ProductShoppingListItem;

	@Getter(GET_SWAP_OPTIONS) getSwapOptions!: ProductShoppingListItem[];

	@Getter(GET_SWAP_CLICKED_REPORT) getSwappedClickedReport!: IReport;

	@Action(SET_SELECTED_SWAP)
	setSelectedSwap!: VuexAction<ProductShoppingListItem>;

	@Action(CLOSE_SWAP_MODAL) closeSwapModal!: () => VuexAction<void>;

	@Action(UPDATE_VISIBLE_INGREDIENTS)
	updateVisibleIngredients!: VuexAction<ProductShoppingListItem>;

	@Prop({ required: false, type: Number }) carouselSlot!: number;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	visible() {
		return this.getSwapOpen;
	}

	private dismiss() {
		this.closeSwapModal();
		return this.getSwapOpen;
	}

	get classSize(): string {
		return this.getSize;
	}

	private selectProduct(item: ProductShoppingListItem) {
		const report = this.getSwappedClickedReport;
		// report.mxrSwapClicked.carouselOffer = {};
		// report.mxrSwapClicked.previousCarouselOffer = {};
		report.mxrSwapClicked!.previousShoppingListOffer = {
			id: this.getSelectedSwap.Id,
			mappedBaseIngredientId: Number.parseInt(
				this.getSelectedSwap.ItemId,
				10
			),
			name: this.getSelectedSwap.Name,
			price: this.getSelectedSwap.Price,
			shoppingListItemName: this.getSelectedSwap.Name,
			upc: this.getSelectedSwap.Upc,
		};
		report.mxrSwapClicked!.shoppingListOffer = {
			id: item.Id,
			mappedBaseIngredientId: Number.parseInt(item.ItemId, 10),
			name: item.Name,
			price: item.Price,
			shoppingListItemName: item.Name,
			upc: item.Upc,
		};
		this.sendReport(report);
		this.setSelectedSwap(item);
		this.updateVisibleIngredients(item);
		this.dismiss();
	}
}
